import {AddToCartReq, Cart} from '@app/core/models';
import {ActionType, createAction, props} from '@ngrx/store';

export const APP_CART = '@App/cart';
export const STORE_CART = '@App/StoreCart';
export const LOAD_CART = '@App/loadCart';
export const ADD_TO_CART = '@App/addToCart';
export const REMOVE_FROM_CART = '@App/removeFromCart';

export const LoadCart = createAction(
  LOAD_CART,
  props<{
    payload: { cartId: number };
  }>()
);
export const AddToCart = createAction(
  ADD_TO_CART,
  props<{
    payload: AddToCartReq;
  }>()
);
export const RemoveFromCart = createAction(
  REMOVE_FROM_CART,
  props<{
    payload: { itemId: number; cartId: number };
  }>()
);
export const StoreCart = createAction(
  APP_CART,
  props<{
    payload: Cart;
  }>()
);

export type CartActions =
  | ActionType<typeof LoadCart>
  | ActionType<typeof AddToCart>
  | ActionType<typeof StoreCart>;
